import React, { useState, useCallback } from 'react';
import { Ribbon } from '@tanium/react-ribbon';
import { Box } from '@tanium/react-box';
import { PALEYELLOW1 } from '@tanium/colors';
import { useTranslation } from 'react-i18next';
import { Button } from '@tanium/react-button';
import { getSessionConfig } from 'utils/Config';
import BannerInModalWrapperDiv from 'components/styles/containers/BannerInModalWrapperDiv';

interface BannerProps {
  isInModal?: boolean;
  onAccept?: (isAccepted: boolean) => void;
}

const FedBanner = ({ isInModal, onAccept }: BannerProps): React.ReactElement | null => {
  const config = getSessionConfig();
  const isGovCloud = config?.isGovCloud;
  const { t } = useTranslation();
  const [isAccepted, setIsAccepted] = useState(!isGovCloud);

  const onAcceptHandler = useCallback(() => {
    setIsAccepted(true);
    onAccept && onAccept(true);
  }, [onAccept]);

  const banner = (
    <Box style={{ backgroundColor: PALEYELLOW1, border: `1px solid ${PALEYELLOW1}` }}>
      <Ribbon data-testid="fed-banner">
        <Box>
          <p style={{ color: '#000' }}>{t('GOV_CLOUD_BANNER_AUTHORIZATION_PARAGRAPH')}</p>
          <p style={{ color: '#000' }}>{t('GOV_CLOUD_BANNER_CONFIDENTIAL_PARAGRAPH')}</p>
          <p style={{ color: '#000' }}>{t('GOV_CLOUD_BANNER_EXPECTATION_PARAGRAPH')}</p>
          <p style={{ color: '#000' }}>{t('GOV_CLOUD_BANNER_CLASSIFICATION_PARAGRAPH')}</p>
          <p style={{ color: '#000' }}>{t('GOV_CLOUD_BANNER_CONTACT_PARAGRAPH')}</p>
          {onAccept && (
            <Box justifyContent="center" display="flex">
              <Button
                data-testid="accept-button"
                disabled={isAccepted}
                onClick={onAcceptHandler}
                style={{ minWidth: '10em' }}
              >
                {isAccepted ? t('ACCEPTED') : t('ACCEPT')}
              </Button>
            </Box>
          )}
        </Box>
      </Ribbon>
    </Box>
  );

  if (isGovCloud) {
    return isInModal ? <BannerInModalWrapperDiv>{banner}</BannerInModalWrapperDiv> : banner;
  }
  return null;
};

export default FedBanner;
